export interface Pagination<Type> {
  page: {
    size: number,
    number: number,
    totalElements: number,
    totalPages: number
  }
  content?: Type[];
}

export class PaginationParams {
  query: string = '';
  pageSize: number = 5;
  pageNumber: number = 0;
  sort: string = '';
  cityId?: string;
  countryId?: string;
  continentId?: string;
  adventureId?: string;


  constructor(data?: PaginationParams) {
    this.query = data?.query ?? '';
    this.pageSize = data?.pageSize ?? 5;
    this.pageNumber = data?.pageNumber ?? 0;
    this.sort = data?.sort ?? '';
    this.cityId = data?.cityId;
    this.countryId = data?.countryId;
    this.continentId = data?.continentId;
    this.adventureId = data?.adventureId;
  }
}
